export const selectOrganizationData = (state) => {
  return (
    state.organizationData &&
    state.organizationData.response &&
    state.organizationData.response.Item &&
    state.organizationData.response.Item.boards.map((rec) => ({ boardId: rec.boardId, boardName: rec.boardName }))
  );
};
